module.exports = __webpack_public_path__ + "svg/illustration-home-fixes.bb5c5f3.svg";